import { useContext } from "react";
import { useParams } from "react-router";
import { GuildRolesAndChannelContext } from "../../../sesh_router";

export function useChannelName(channel_id: string, include_hashtag = true) {
	let { server_id } = useParams<{
		server_id: string;
	}>();

	const context = useContext(GuildRolesAndChannelContext);

	const channel_name = context
		?.get(server_id)
		?.channels?.find((val) => val.id === channel_id)?.name;

	return channel_name
		? `${include_hashtag ? "#" : ""}${channel_name}`
		: channel_id;
}
